import { AfterViewInit, Component, ElementRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { microAppInitialized } from '@mynexus/mfe-core';
import { NotificationsService } from '@core/service/notifications.service';

@Component({
    selector: 'app-notification',
    templateUrl: './mnc-notification.component.html',
    styleUrls: ['./mnc-notification.component.scss'],
    standalone: false
})
export class MncNotificationComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly notificationsService = inject(NotificationsService);

  constructor(
    private ref: ElementRef,
    private router: Router
  ) {
  }

  @Input() set url(value: string) {
    this.router.navigate([value]);
  }

  ngAfterViewInit(): void {
    microAppInitialized(this.ref, this.router as any, 'Notification')
  }

  public ngOnInit(): void {
    this.notificationsService.setupConnection();
  }

  public ngOnDestroy(): void {
    this.notificationsService.closeConnection();
  }
}
